import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { productCategoryDto } from 'src/app/model/category/productCategoryDto';
import { CategoryService } from 'src/app/services/dataServices/product-service/categoryService';

@Component({
    selector: 'app-common-feature-categories-item',
    templateUrl: './common-feature-categories-item.component.html',
    styleUrls: ['./common-feature-categories-item.component.css'],
    standalone: false
})
export class CommonFeatureCategoriesItemComponent implements OnInit {
  @Input() category: productCategoryDto;
  @Output() edit = new EventEmitter<void>();
  @Output() close = new EventEmitter<'ABORT' | 'SAVE' | 'DELETE'>();
  saving = false;
  form: UntypedFormGroup;
  showDetails = false;
  private initialState: any;
  formChanged = false;

  constructor(private cdr: ChangeDetectorRef,
    private categoryService: CategoryService) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      filterOption: new UntypedFormControl(this.category.filterOption),
    });

    this.initialState = this.form.value;

    this.form.valueChanges.subscribe((value) => {
      this.formChanged = JSON.stringify(value) !== JSON.stringify(this.initialState);
    });

    this.cdr.detectChanges();
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  editCategory(): void {
    this.edit.emit();
  }

  cancel(): void {
    this.form.reset(this.initialState);
    this.formChanged = false;
    this.close.emit('ABORT');
  }

  delete(): void {
    this.close.emit('DELETE');
  }

  async save(): Promise<void> {
    this.saving = true;
    const newValue = this.form.value.filterOption;
  
    try {
      const updated = await this.categoryService.updateFilterOption(this.category.id, newValue);
      this.initialState = this.form.value;
      this.formChanged = false;
      this.category.filterOption = updated.filterOption;
      this.close.emit('SAVE');
    } catch (err) {
      console.error('Error saving category:', err);
    } finally {
      this.saving = false;
      this.cdr.detectChanges(); 
  }
}
}
